/* eslint-disable sort-keys */
/* eslint-disable max-lines */
/* eslint-disable max-len */
/* eslint-disable complexity */
import {
    EmbedContext, EmbedStateValue,
} from 'components/EmbedContext'

import {
    HeroExclamationTriangleIconSolid,
    NinchatBlockedIcon, NinchatCameraVideoIcon,
    NinchatSpinnerIcon,
} from 'components/Icon'

import React, {
    useContext,
    useEffect, useLayoutEffect, useRef, useState,
} from 'react'

import {
    channelAvatar,
    errorButtonWraper,
    errorMessage,
    errorTitle,
    errorWrapper, heroContent, heroContentInChat, heroContentInQueue, heroWrapper,
    memberImages, moreUsers, queuePosition, skeletonLoader, spinnerWrapper, subtitle,
    subtitleInQueue,
    title, titleInQueue, videoMeetingWrapper,
} from './styles'

import {
    useAppDispatch,
    useAppSelector,
} from 'hooks'

import Button from 'components/Button'
import {EmbedEvent} from 'embed/types/events'
import LetterAvatar from 'components/Avatar/LetterAvatar'
import {NinchatUserAttributes} from 'api/types/attributes'
import {QueueProps} from 'components/Queue/types'

import User from 'components/User'

import {config} from 'embed/listeners'
import {isPropsObjectEqual} from 'utils/props'
import {isVideoChannel as isVideoChannelCheck} from 'utils/channels'
import {jitsiMeet} from 'actions/jitsi'
import {styled} from 'stitches/config'

import {useChannels} from 'hooks/ninchat'
import {useSendToParent} from 'embed/utils/event'
import {
    useTranslation,
} from 'react-i18next'

const StyledEmbedHeroWrapper = styled('div', heroWrapper)
const StyledHeroContent = styled('div', heroContent)
const StyledHeroContentInQueue = styled('div', heroContentInQueue)
const StyledHeroContentInChat = styled('div', heroContentInChat)
const StyledSpinnerWrapper = styled('div', spinnerWrapper)
const StyledTitle = styled('div', title)
const StyledSubtitle = styled('div', subtitle)

const StyledTitleInQueue = styled('div', titleInQueue)
const StyledSubtitleInQueue = styled('div', subtitleInQueue)
const StyledMemberImages = styled('div', memberImages)
const StyledChannelAvatar = styled('div', channelAvatar)
const StyledMoreUsers = styled('div', moreUsers)
const StyledVideoMeetingWrapper = styled('div', videoMeetingWrapper)

const StyledErrorWrapper = styled('div', errorWrapper)
const StyledErrorTitle = styled('div', errorTitle)
const StyledErrorMessage = styled('div', errorMessage)
const StyledErrorButtonWrapper = styled('div', errorButtonWraper)
const StyledQueuePosition = styled('span', queuePosition)

const NinchatSkeletonLoader = styled('div', skeletonLoader)

interface EmbedHeroProps {
    queueProps?: QueueProps
    channelId?: string
    members?: Array<{
        details: NinchatUserAttributes;
        id: string;
    }>,
    type?: 'queue' | 'chat' | 'questionnaire' | 'login'
    resetEmbed: (clearData?: boolean) => void
}

export const EmbedHero = (props: EmbedHeroProps) => {
    const {
        type, queueProps, channelId, members: channelMembers, resetEmbed,
    } = props

    const {t} = useTranslation()
    const dispatch = useAppDispatch()
    const heroRef = useRef<HTMLDivElement>(null)
    const embed = useContext(EmbedContext)
    const sendToParent = useSendToParent()
    const targetOrigin = config.get('targetOrigin') || ''
    const [heroHeight, setHeroHeight] = useState(0)

    const currentChannel = useChannels([channelId || ''].filter((id) => Boolean(id)))?.[channelId || ''] ?? {}
    const isVideoChannel = isVideoChannelCheck(currentChannel)
    const [hideHero, setHideHero] = useState(false)

    const isClosed = useAppSelector(({ninchat}) => {
        if (channelId) {
            return Boolean(ninchat.user_channels[channelId]?.channel_attrs?.closed)
        }

        return false
    })

    const {isJitsiActive} = useAppSelector(({jitsi}) => ({isJitsiActive: jitsi?.isActive ?? false}), isPropsObjectEqual)

    const joinVideoMeeting = () => {
        dispatch(jitsiMeet(channelId || ''))
    }

    const chatScroll = (_e: Event) => {
        if (isJitsiActive) {
            return
        }
        setHideHero(true)
    }

    useEffect(() => {
        if (isJitsiActive) {
            setHideHero(true)
        }
    }, [isJitsiActive])

    useEffect(() => {
        if (embed?.embedState?.chatBacklogRef?.current && embed?.embedState?.chatTextareaRef?.current) {
            const backlog = embed?.embedState?.chatBacklogRef?.current
            const textarea = embed?.embedState?.chatTextareaRef?.current

            if (!textarea || !backlog) {
                return undefined
            }

            const observer = new ResizeObserver(() => {
                const hasGrown = backlog.scrollHeight > backlog.clientHeight
                if (hasGrown) {
                    setHideHero(true)
                }
            })

            observer.observe(textarea)

            return () => observer.disconnect()
        }
        return undefined
    }, [embed?.embedState?.chatBacklogRef?.current, embed?.embedState?.chatTextareaRef?.current])

    useEffect(() => {
        if (embed?.embedState?.chatBacklogRef?.current) {
            embed?.embedState?.chatBacklogRef?.current.addEventListener('scroll', chatScroll)
            return () => {
                embed?.embedState?.chatBacklogRef?.current?.removeEventListener('scroll', chatScroll)
            }
        }
        return undefined
    }, [embed?.embedState?.chatBacklogRef?.current])

    useEffect(() => {
        const handleClick = (ev: MouseEvent) => {
            const target = ev.target as HTMLElement
            if (!heroRef.current?.contains(target) && embed?.embedState?.heroFullAbsoluteVisible) {
                ev.stopPropagation()

                embed?.setEmbedState((prevState) => ({
                    ...prevState,
                    heroFullAbsoluteVisible: false,
                }))
            }
        }
        document.addEventListener('click', handleClick, true)

        return () => {
            document.removeEventListener('click', handleClick, true)
        }
    }, [embed?.embedState?.heroFullAbsoluteVisible])

    // eslint-disable-next-line no-constant-binary-expression
    const membersToRender = channelMembers ? [...channelMembers] : []

    useEffect(() => {
        if (type === 'chat' && !membersToRender[0]?.details) {
            sendToParent({
                event: EmbedEvent.EmbedHero,
                heroFullVisible: false,
                targetOrigin,
            })
            embed?.setEmbedState((prevState: EmbedStateValue) => ({
                ...prevState,
                heroFullVisible: false,
            }))
        } else if (hideHero && type === 'chat') {
            sendToParent({
                event: EmbedEvent.EmbedHero,
                heroFullVisible: false,
                targetOrigin,
            })
            embed?.setEmbedState((prevState: EmbedStateValue) => ({
                ...prevState,
                heroFullVisible: false,
            }))
        } else {
            sendToParent({
                event: EmbedEvent.EmbedHero,
                heroFullVisible: true,
                targetOrigin,
            })
            embed?.setEmbedState((prevState: EmbedStateValue) => ({
                ...prevState,
                heroFullVisible: true,
            }))
        }
    }, [type, hideHero, JSON.stringify(membersToRender), isVideoChannel])

    useLayoutEffect(() => {
        const height = heroRef?.current?.scrollHeight || 0
        setHeroHeight(height)
    }, [hideHero])

    if (embed?.embedState?.error || embed?.embedState?.connectionError) {
        return (
            <StyledEmbedHeroWrapper isVideoChannel={isVideoChannel} ref={heroRef} type={type}>
                <StyledErrorWrapper>
                    <StyledErrorTitle><HeroExclamationTriangleIconSolid />{embed.embedState.connectionError?.title || embed.embedState.error?.title}</StyledErrorTitle>
                    <StyledErrorMessage>{embed.embedState.connectionError?.message || embed.embedState.error?.message}</StyledErrorMessage>
                    {!embed.embedState.connectionError && <StyledErrorButtonWrapper><Button onPress={() => resetEmbed()} text={t('Close window')} /></StyledErrorButtonWrapper>}
                </StyledErrorWrapper>
            </StyledEmbedHeroWrapper>
        )
    }

    let hideComponent = hideHero
    let hideHeroFullInfo = hideHero

    if (type === 'chat' && !membersToRender[0]?.details && !isVideoChannel) {
        hideComponent = true
    }

    if (hideHero && type === 'chat' && !isVideoChannel) {
        hideComponent = true
    }

    if (embed?.embedState?.heroFullAbsoluteVisible && type === 'chat') {
        hideComponent = false
        hideHeroFullInfo = false
    }

    const isChannel = embed?.channelId
    const iconsToDisplay = 5

    return (
        <StyledEmbedHeroWrapper css={{$$heroHeight: `${heroHeight}px`}} data-id='embed-hero' hide={hideComponent} isClosed={isClosed} isVideoChannel={isVideoChannel} ref={heroRef} type={type}>
            <StyledHeroContent>
                {type === 'queue'
                    ? (
                        <StyledHeroContentInQueue reverseEmbedHeroContentOrdering={!!embed?.reverseEmbedHeroContentOrdering}>
                            {queueProps?.queue_attrs?.closed ?
                                <NinchatBlockedIcon />
                                :
                                embed?.useSkeletonLoader ?
                                    <div>
                                        <StyledTitleInQueue>{t('Please wait')}</StyledTitleInQueue>
                                        <NinchatSkeletonLoader>
                                            <div>{t('You are #{{queuePosition}} in queue', {queuePosition: queueProps?.queue_position})}</div>
                                        </NinchatSkeletonLoader>
                                    </div>
                                    : (
                                        <StyledSpinnerWrapper>
                                            <NinchatSpinnerIcon id={Math.random().toString()} /><StyledQueuePosition aria-atomic='true' aria-live='polite'>{queueProps?.queue_position}</StyledQueuePosition>
                                        </StyledSpinnerWrapper>
                                    )}
                            {
                                queueProps?.queue_attrs.closed
                                    ? (
                                        <div>
                                            <StyledTitleInQueue>{t('Service has been closed')}</StyledTitleInQueue>
                                            <StyledSubtitleInQueue>{t('Unfortunately we can’t service any more people at this time.')}</StyledSubtitleInQueue>
                                        </div>
                                    )
                                    : embed?.useSkeletonLoader
                                        ? null
                                        : (
                                            <div>
                                                <StyledTitleInQueue aria-atomic='true' aria-live='polite'>{queueProps?.queue_position === 1 ? t('You are next in queue', {queuePosition: queueProps?.queue_position}) : t('You are in queue', {queuePosition: queueProps?.queue_position})}</StyledTitleInQueue>
                                                <StyledSubtitleInQueue>{queueProps?.queue_position === 1 ? t('Please wait a moment!', {queuePosition: queueProps?.queue_position}) : t('Please wait', {queuePosition: queueProps?.queue_position})}</StyledSubtitleInQueue>
                                            </div>
                                        )
                            }
                        </StyledHeroContentInQueue>
                    )
                    : null}
                {type === 'chat'
                    ? (
                        <StyledHeroContentInChat>
                            {hideHeroFullInfo
                                ? null :
                                isChannel
                                    ? currentChannel?.channel_attrs?.name ?
                                        <div>
                                            <StyledChannelAvatar>
                                                <LetterAvatar name={currentChannel?.channel_attrs?.name} size='mid' />
                                            </StyledChannelAvatar>
                                            <StyledTitle>{currentChannel?.channel_attrs?.name}</StyledTitle>
                                            <StyledSubtitle>{currentChannel?.channel_attrs?.topic || ''}</StyledSubtitle>
                                        </div>
                                        : null

                                    : (
                                        <div>
                                            <StyledMemberImages>
                                                {membersToRender?.filter((_member, index) => index < iconsToDisplay - 1 || membersToRender.length === iconsToDisplay).map((member) => (member?.id ? <User avatarIconOverride={embed?.agentAvatar} avatarOnly forceLetterAvatar={!!embed?.agentName} key={member.id} nameOverride={embed?.agentName || ''} size={'mid' as any} userId={member.id} /> : null))}
                                                {membersToRender.length > iconsToDisplay ? <StyledMoreUsers>+{membersToRender.length - iconsToDisplay + 1}</StyledMoreUsers> : null}
                                            </StyledMemberImages>
                                            <StyledTitle>{membersToRender?.filter((_member, index) => index < iconsToDisplay - 1 || membersToRender.length === iconsToDisplay)
                                                .map((member) => (embed?.agentName ? embed.agentName : member?.details?.name + (membersToRender.length > 1 && (embed?.agentJobTitle ?? member?.details?.info?.job_title) ? `(${embed?.agentJobTitle ?? member?.details?.info?.job_title})` : '')))
                                                .join(', ') || ''}{membersToRender.length > iconsToDisplay ? <span> +{membersToRender.length - iconsToDisplay + 1}</span> : ''}
                                            </StyledTitle>
                                            <StyledSubtitle>{membersToRender.length > 1 ? '' : membersToRender?.map((member) => embed?.agentJobTitle ?? member?.details?.info?.job_title).join(', ') || ''}</StyledSubtitle>
                                        </div>
                                    )}
                            {isVideoChannel && !isClosed && !isJitsiActive
                                ? (
                                    <StyledVideoMeetingWrapper noMargin={hideHeroFullInfo} >
                                        <Button
                                            color='filled'
                                            css={{
                                                '$colors-buttonFilledBackground': '$colors-buttonVideoBackground',
                                                '$colors-buttonFilledBackgroundActive': '$colors-buttonVideoBackgroundActive',
                                                '$colors-buttonFilledBackgroundDisabled': '$colors-buttonVideoBackgroundDisabled',
                                                '$colors-buttonFilledBackgroundFocus': '$colors-buttonVideoBackgroundFocus',
                                                '$colors-buttonFilledBackgroundHover': '$colors-buttonVideoBackgroundHover',
                                                '$colors-buttonFilledBorder': '$colors-buttonVideoBorder',
                                                '$colors-buttonFilledBorderActive': '$colors-buttonVideoBorderActive',
                                                '$colors-buttonFilledBorderDisabled': '$colors-buttonVideoBorderDisabled',
                                                '$colors-buttonFilledBorderFocus': '$colors-buttonVideoBorderFocus',
                                                '$colors-buttonFilledBorderHover': '$colors-buttonVideoBorderHover',
                                                '$colors-buttonFilledIcon': '$colors-buttonVideoIcon',
                                                '$colors-buttonFilledIconDisabled': '$colors-buttonVideoIconDisabled',
                                                '$colors-buttonFilledIconFocus': '$colors-buttonVideoIconFocus',
                                                '$colors-buttonFilledIconActive': '$colors-buttonVideoIconActive',
                                                '$colors-buttonFilledIconHover': '$colors-buttonVideoIconHover',
                                                '$colors-buttonFilledText': '$colors-buttonVideoText',
                                                '$colors-buttonFilledTextDisabled': '$colors-buttonVideoTextDisabled',
                                                '$colors-buttonFilledTextActive': '$colors-buttonVideoTextActive',
                                                '$colors-buttonFilledTextFocus': '$colors-buttonVideoTextFocus',
                                                '$colors-buttonFilledTextHover': '$colors-buttonVideoTextHover',
                                                '$colors-buttonFilledOutlineFocus': '$colors-buttonVideoOutlineFocus',
                                                'borderRadius': '$buttonVideo',
                                                'borderStyle': '$buttonVideo',
                                                'borderWidth': '$buttonVideo',
                                                'fontFamily': '$buttonVideo',
                                                'fontSize': '$buttonVideo',
                                                'fontStyle': '$buttonVideo',
                                                'fontVariant': '$buttonVideo',
                                                'fontWeight': '$buttonVideo',
                                                'lineHeight': '$buttonVideo',
                                                'padding': '$buttonVideo',
                                            }}
                                            iconLeft={NinchatCameraVideoIcon}
                                            onPress={joinVideoMeeting}
                                            text={t('Join video meeting')}
                                        />

                                    </StyledVideoMeetingWrapper>
                                )
                                : null}
                        </StyledHeroContentInChat>
                    )
                    : null}
            </StyledHeroContent>
        </StyledEmbedHeroWrapper>
    )
}

EmbedHero.defaultProps = {
    channelId: null,
    members: [],
    queueProps: null,
    type: 'queue',
}
